export default __webpack_public_path__ + "6497a633d802926f5a73e5cf52c51b94.svg";